import React, { Component } from 'react';
import { Form, Grid } from 'semantic-ui-react';

import '../../css/login.css';

import RegisterCard from './RegisterCard';
import IconInput from '../common/IconInput';
import SecureInput from '../common/SecureInput';
import AnimatedIconButton from '../common/AnimatedIconButton';

import { VALIDATION_STATE } from '../../misc/utils';

/**
 * Komponente fuer die Anmeldung
 * @type {Login}
 */
export default class Register extends Component<Props, State> {
    /**
     * Erzeugt die Komponente
     * @param {Object} props Die Properties der Komponente
     */
    constructor(props: Object) {
        super(props);

        this.state = {
            mail: '',
            password: '',
            setupKey: '',
            isValid: VALIDATION_STATE.NONE,
        };
    }

    /**
     * Ruft den Callback auf wenn die Anmeldung betaetigt wird
     */
    onRegister = (): void => {
        const { callback } = this.props;
        const { mail, password, setupKey } = this.state;

        const isValid = mail.trim() !== '' && password.trim() !== '' && setupKey.trim() !== '';

        if (isValid) {
            callback(mail, password, setupKey);
        } else {
            this.setState({
                isValid: VALIDATION_STATE.ERROR,
            });
        }
    };

    /**
     * Workaround fuer Submit Probleme im Firefox
     * @param {Event} e Das Event das ausgeloest wurde
     */
    handleKeyPress = (e: SyntheticEvent<>): void => {
        const { loader } = this.props;

        if (e.key === 'Enter' && !loader) {
            this.onRegister();
        }
    };

    /**
     * Rendert die Komponente
     * @return {JSX} JSX Markup
     */
    render() {
        const { loader, title, mail, password, button, setupKey } = this.props;
        const { isValid } = this.state;

        return (
            <RegisterCard
                title={title}
                buttons={
                    <div className='authButtons'>
                        <Grid columns='equal'>
                            <Grid.Column>
                                <AnimatedIconButton onClick={this.onRegister} icon='arrow circle right' text={button} />
                            </Grid.Column>
                        </Grid>
                    </div>
                }
            >
                <Form onSubmit={this.onRegister}>
                    <Grid columns='equal'>
                        <Grid.Row>
                            <Grid.Column>
                                <IconInput
                                    validationState={isValid}
                                    disabled={loader}
                                    placeholder={mail}
                                    changeCallback={val => this.setState({ mail: val, isValid: VALIDATION_STATE.NONE })}
                                    icon='mail'
                                    handleKeyPress={this.handleKeyPress}
                                />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <SecureInput
                                    validationState={isValid}
                                    disabled={loader}
                                    placeholder={password}
                                    changeCallback={val => this.setState({ password: val, isValid: VALIDATION_STATE.NONE })}
                                    type='password'
                                    handleKeyPress={this.handleKeyPress}
                                />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <IconInput
                                    validationState={isValid}
                                    disabled={loader}
                                    placeholder={setupKey}
                                    changeCallback={val => this.setState({ setupKey: val, isValid: VALIDATION_STATE.NONE })}
                                    icon='key'
                                    handleKeyPress={this.handleKeyPress}
                                />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Form>
            </RegisterCard>
        );
    }
}
